import React from 'react';
import { Text } from '@chakra-ui/react';
import { useTokens } from '../../../../context/TokenProvider';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useCreateOfficerAssessment } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { localise } from '../../../../services/lang/lang';
import { makeMed4 } from '../../../../styles/textStyles';
import AddButton from '../../AddButton/AddButton';
const AddOfficerAssessmentButton = ({ remoteSubmission, onCreated, ...rest }) => {
    const tokens = useTokens();
    const createOfficerAssessment = useGenericMutationUseCase(useCreateOfficerAssessment);
    const handleClick = () => {
        createOfficerAssessment.execute({
            data: {
                remote_submission_id: remoteSubmission.id,
            },
        }, undefined, {
            onSuccess: (response) => {
                const officerAssessment = unwrapModel(response);
                if (!officerAssessment)
                    return;
                onCreated(officerAssessment);
            },
        });
    };
    return (React.createElement(AddButton, { paddingRight: tokens.Spacing04, paddingLeft: tokens.Spacing04, "data-testid": "add_officer_assessment_button", isLoading: createOfficerAssessment.isPending, onClick: () => handleClick(), ...rest },
        React.createElement(Text, { sx: makeMed4(tokens) }, localise('ADD_OFFICER_ASSESSMENT'))));
};
export default AddOfficerAssessmentButton;
